/**
 * Moves the grey progress thumb under mobile product card image sliders on
 * collection pages (snippets/custom-card-mobile-slider.liquid).
 *
 * Uses one capture-phase scroll listener on document (scroll events don't
 * bubble, but they do pass through the capture phase), so cards re-rendered
 * by AJAX filtering/sorting/pagination work without re-binding.
 */
(function () {
  function update(track) {
    var root = track.closest('.card-mslider');
    if (!root) return;

    var clientWidth = track.clientWidth;
    var scrollWidth = track.scrollWidth;
    var maxScroll = scrollWidth - clientWidth;
    if (clientWidth <= 0 || maxScroll <= 0) return;

    var thumbWidth = (clientWidth / scrollWidth) * 100;
    var scrollLeft = Math.abs(track.scrollLeft); // RTL-safe
    var shift = (scrollLeft / maxScroll) * (100 - thumbWidth);

    root.style.setProperty('--thumbW', thumbWidth + '%');
    root.style.setProperty('--thumbShift', shift + '%');
  }

  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('card-mslider__track')) {
        update(t);
      }
    },
    { capture: true, passive: true }
  );
})();
